import React, { useState } from 'react';
import {
  coerceDeliveryAddressStreetNumber,
  isFilledDeliveryAddressStreetNumber,
} from '../../utils/deliveryAddressStreetNumber';
import { Modal, Button, Message, Icon, Checkbox, Segment, Header } from 'semantic-ui-react';

interface DeliveryAddress {
  cep?: string;
  endereco?: string;
  numero?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  complemento?: string;
  referencia?: string;
}

interface FastchipAddressModalProps {
  open: boolean;
  onConfirm: () => void;
  deliveryAddress?: DeliveryAddress;
}

export const FastchipAddressModal: React.FC<FastchipAddressModalProps> = ({
  open,
  onConfirm,
  deliveryAddress
}) => {
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirm = () => {
    if (confirmed) {
      setConfirmed(false);
      onConfirm();
    }
  };

  const formatAddress = () => {
    if (!deliveryAddress) {
      return 'Endereço ainda não preenchido';
    }

    const parts: string[] = [];
    
    if (deliveryAddress.endereco) {
      let enderecoCompleto = deliveryAddress.endereco;
      if (isFilledDeliveryAddressStreetNumber(deliveryAddress.numero)) {
        enderecoCompleto += `, ${coerceDeliveryAddressStreetNumber(deliveryAddress.numero)}`;
      }
      parts.push(enderecoCompleto);
    }
    
    if (deliveryAddress.bairro) {
      parts.push(deliveryAddress.bairro);
    }
    
    if (deliveryAddress.cidade && deliveryAddress.estado) {
      parts.push(`${deliveryAddress.cidade} - ${deliveryAddress.estado}`);
    } else if (deliveryAddress.cidade) {
      parts.push(deliveryAddress.cidade);
    } else if (deliveryAddress.estado) {
      parts.push(deliveryAddress.estado);
    }
    
    if (deliveryAddress.cep) {
      parts.push(`CEP: ${deliveryAddress.cep}`);
    }
    
    if (deliveryAddress.complemento) {
      parts.push(`Complemento: ${deliveryAddress.complemento}`);
    }
    
    if (deliveryAddress.referencia) {
      parts.push(`Referência: ${deliveryAddress.referencia}`);
    }

    return parts.length > 0 ? parts.join('\n') : 'Endereço ainda não preenchido';
  };

  return (
    <Modal open={open} onClose={() => {}} size="small" closeOnDimmerClick={false}>
      <Modal.Header>
        <Icon name="shipping fast" color="orange" />
        Importante para contratos Fastchip
      </Modal.Header>
      <Modal.Content>
        <Message warning>
          <Message.Header>⚠️ Atenção - Endereço de Entrega</Message.Header>
          <p>
            O envio do Fastchip é realizado via Correios. Certifique-se de que o endereço de entrega esteja
            completo e correto (rua, número, bairro, cidade e CEP), pois ele será utilizado para o envio dos chips.
          </p>
        </Message>

        {deliveryAddress && (
          <Segment style={{ marginTop: '15px', backgroundColor: '#f9f9f9' }}>
            <Header as="h4" style={{ marginBottom: '10px', color: '#2c3e50' }}>
              <Icon name="map marker alternate" />
              Endereço de Entrega
            </Header>
            <div style={{ 
              whiteSpace: 'pre-line', 
              fontFamily: 'monospace', 
              fontSize: '0.95em',
              lineHeight: '1.6',
              color: '#333'
            }}>
              {formatAddress()}
            </div>
          </Segment>
        )}

        <div style={{ marginTop: '20px' }}>
          <Checkbox
            label="Li e confirmo que o endereço de entrega está correto"
            checked={confirmed}
            onChange={(e, data) => setConfirmed(data.checked || false)}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={handleConfirm} disabled={!confirmed}>
          <Icon name="check" />
          Confirmar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
